export default {
    title: "Uw goedkeurende manager is {email}"
}